import React from "react";
import { Link } from "react-router-dom";
import AdCard from "../ad-card/AdCard";
import { ClassifiedType } from "../../../types/main-types/mainTypes";

interface AdListProps {
  adList: ClassifiedType[];
  isBoosted?: boolean;
}

function AdList({ adList, isBoosted }: AdListProps) {
  return (
    <div className="d-flex flex-column gap-2">
      {adList?.map((ad) => (
        <Link
          key={ad?.id}
          to={`/ads/${ad?.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <AdCard adDetails={ad} isBoosted={isBoosted} />
        </Link>
      ))}
    </div>
  );
}

export default AdList;
